import React from "react";
import humanIcon from "../../../images/icons/people.png";
import technologyIcon from "../../../images/icons/technology.png";
import dataIcon from "../../../images/icons/data.png";
import moneyIcon from "../../../images/icons/save-money.png";
import { useTranslation } from "react-i18next";
import i18n from "../../../language/i18n";
import { normalizeLang } from "../../../utils/localeDataLoader";
import {
  filterIntroduceCardsBySubtitle,
  INTRODUCE_CARD_GROUPS,
  useIntroduceCapacitiesQuery,
  useIntroduceOverviewCardsQuery,
  useIntroduceOverviewPageQuery,
  useIntroduceOverviewQuery,
} from "hooks";
import IntroduceCardGrid from "./IntroduceCardGrid";
import IntroduceSectionTitle from "./IntroduceSectionTitle";
const CAPACITY_ICONS = [humanIcon, technologyIcon, dataIcon, moneyIcon];

function IntroduceOverview({ showActivities = true }) {
  useTranslation();
  const currentLang = normalizeLang(i18n.language);
  const { data: pageData } = useIntroduceOverviewPageQuery(currentLang);
  const { data: overviewData } = useIntroduceOverviewQuery(currentLang);
  const { data: capacitiesData = [] } =
    useIntroduceCapacitiesQuery(currentLang);
  const { data: overviewCards = [] } =
    useIntroduceOverviewCardsQuery(currentLang);
  const businessActivityCards = filterIntroduceCardsBySubtitle(
    overviewCards,
    INTRODUCE_CARD_GROUPS.businessActivities,
  );

  if (!pageData) {
    return <div>Loading...</div>;
  }

  return (
    <div className="introduce-overview">
      <section className="introduce-overview__intro">
        {overviewData?.description && (
          <div
            className="introduce-overview__lead quill-content"
            dangerouslySetInnerHTML={{ __html: overviewData.description }}
          />
        )}
      </section>

      {showActivities && <section className="introduce-overview__section introduce-overview__section--activities">
        <IntroduceSectionTitle>
          {pageData.businessActivities}
        </IntroduceSectionTitle>

        {businessActivityCards.length > 0 ? (
          <IntroduceCardGrid cards={businessActivityCards} />
        ) : (
          <div className="introduce__content-img">
            <img src={overviewData?.image} alt="banner su menh" />
          </div>
        )}
      </section>}
      <section className="introduce-overview__section introduce-overview__section--capacities">
        <IntroduceSectionTitle>{pageData.capabilities}</IntroduceSectionTitle>

        <div className="introduce__content-capacity">
        <ul>
          {capacitiesData.map((item, index) => (
            <li
              key={item.id}
              style={{ "--introduce-delay": `${index * 90}ms` }}
            >
              <div className="introduce__content-capacity-header">
                <div className="introduce__content-capacity-img">
                  <img
                    src={CAPACITY_ICONS[index] || CAPACITY_ICONS[0]}
                    alt=""
                  />
                </div>
              </div>
              <div className="introduce__content-capacity-title">
                <h2>
                  {item.title}
                </h2>
                <p>
                  {item.subtitle}
                </p>
              </div>
              <div className="introduce__content-capacity-text">
                <div
                  className="quill-content"
                  dangerouslySetInnerHTML={{
                    __html: item.description || "",
                  }}
                />
                <div
                  className="quill-content"
                  dangerouslySetInnerHTML={{
                    __html: item.extraDescription || "",
                  }}
                />
              </div>
            </li>
          ))}
        </ul>
        </div>
      </section>
      </div>
  );
}

export default IntroduceOverview;
